// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../../shared/Ui.re.mjs";
import * as Ideas from "../../organisms/Ideas.re.mjs";
import * as React from "react";
import * as Layout from "../../shared/Layout.re.mjs";
import * as Landing from "../../templates/Landing.re.mjs";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GalleryList from "../../organisms/GalleryList.re.mjs";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactHelmetAsync from "react-helmet-async";
import Aipainter_afterJpg from "./aipainter_after.jpg";
import Aipainter_beforeJpg from "./aipainter_before.jpg";

import { css, cx } from '@linaria/core'
;

var items = [
  {
    id: "5a25c7f887456fcc128b465b",
    name: "Oil Painting from Photo",
    description: "12\"x16\"",
    price: 174,
    image: {
      src: "https://images.instapainting.com/5a51d40c87456fc0318b4578.jpg",
      alt: "Oil painting of a girl riding a horse painted in the style of Young American Girl by Francis Picabia",
      imgixParams: {
        auto: "format,enhance"
      }
    },
    link: "/products/gallery/custphotoreal/5a25c7f887456fcc128b465b/?order=1"
  },
  {
    id: "59dd347087456f63518b46ff",
    name: "Oil Painting from Photo",
    description: "16\"x 20\"",
    price: 226,
    image: {
      src: "https://images.instapainting.com/59ec255f87456f63708b456c.jpg",
      alt: "Oil portrait of a closeup of a man and a woman in the style of Dynamism of a Cyclist by Umberto Boccion",
      imgixParams: {
        auto: "format,enhance"
      }
    },
    link: "/products/gallery/custphotoreal/59dd347087456f63518b46ff/?order=1"
  },
  {
    id: "5a1f1ed587456f09258b45a5",
    name: "Oil Painting from Photo",
    description: "20\"x 24\"",
    price: 219,
    image: {
      src: "https://images.instapainting.com/5a3ba91c87456f03208b4572.jpg",
      alt: "Oil portrait of Warren Buffet in the style of Orange Outline by Franz Kline",
      imgixParams: {
        auto: "format,enhance"
      }
    },
    link: "/products/gallery/custphotoreal/5a1f1ed587456f09258b45a5/?order=1"
  },
  {
    id: "6205c64772f2858ebc8b457a",
    name: "Oil Painting from Photo",
    description: "16\"x 20\"",
    price: 226,
    image: {
      src: "https://images.instapainting.com/620f142cf1b8cd401d8b4569.jpg",
      alt: "Oil portrait of Warren Buffet in the style of Orange Outline by Franz Kline",
      imgixParams: {
        auto: "format,enhance",
        fit: "crop",
        crop: "focalpoint",
        "fp-z": "1.25"
      }
    },
    link: "/products/gallery/custphotoreal/6205c64772f2858ebc8b457a/?order=1"
  },
  {
    id: "622b96281324127e688b4568",
    name: "Watercolor Painting from Photo",
    description: "12\"x 16\"",
    price: 147,
    image: {
      src: "https://images.instapainting.com/6231f90aeb69a2e3718b4572.jpg",
      alt: "Watercolor portrait of an older lady with a hint of the style of Dynamism of a Cyclist by Umberto Boccion",
      imgixParams: {
        auto: "format,enhance"
      }
    },
    link: "/products/gallery/custwatercolor/622b96281324127e688b4568/?order=1"
  }
];

var ideas_0 = {
  id: "royal-portraits",
  name: "Classical Royal Portraits",
  description: "Send us a headshot, we'll turn it into a classic",
  price: 0,
  image: {
    src: "https://images.instapainting.com/5fb4e32787456f55618b456d_w0.jpg",
    alt: "Oil portrait of a couple painted into a classical oil painting of pilgrims.",
    imgixParams: {
      fit: "crop",
      crop: "focalpoint",
      "fp-z": "1.1",
      "fp-y": "0.32"
    }
  },
  link: "/products/gallery/custphotoreal/5fa6f28187456fe3238b4581/?order=1"
};

var ideas_1 = {
  id: "merge-photos",
  name: "Make a Scene",
  description: "Give us multiple photos and we can make them into one scene",
  price: 0,
  image: {
    src: "https://images.instapainting.com/61b9ae0c705402c8108b4572.jpg",
    alt: "Oil painting of a sunset with some kids in the foreground looking at it.",
    imgixParams: {
      fit: "crop",
      crop: "focalpoint"
    }
  },
  link: "/products/gallery/custphotoreal/61a7e08c50a069a2068b4575/?order=1"
};

var ideas_2 = {
  id: "kitsch",
  name: "Kitschy Portraits",
  description: "Bad taste, but great as a gift",
  price: 0,
  image: {
    src: "https://images.instapainting.com/61d9ac8a183a3eee218b4570_w0.jpg?fit=crop&crop=focalpoint&fp-z=1.45",
    alt: "Kitschy oil portrait of a dog as Captain Marvel",
    imgixParams: {
      fit: "crop",
      crop: "focalpoint",
      "fp-z": "1.25"
    }
  },
  link: "/products/gallery/custphotoreal/6191b9203f4a8a42048b459b/?order=1"
};

var ideas = [
  ideas_0,
  ideas_1,
  ideas_2
];

var Plupload = {};

function InstantPreviewPage$UploadButton(props) {
  var containerEl = React.useRef(null);
  var buttonEl = React.useRef(null);
  var filelistEl = React.useRef(null);
  React.useEffect((function () {
          var makeUploader = ((args) => {
          return import('plupload-es6').then((imp) => {
            const { plupload, moxie } = imp.default;
            const pl = plupload;
          window.plupload=pl; return Promise.resolve(new pl.Uploader(args))})
        });
          ((function (__x) {
                  return Js_promise.then_((function (uploader) {
                                return Promise.resolve((uploader.init(), undefined));
                              }), __x);
                })(makeUploader({
                      runtimes: "html5,html4",
                      browse_button: buttonEl.current,
                      container: containerEl.current,
                      url: "/updates/create-chunked/",
                      multi_selection: false,
                      chunk_size: "200kb",
                      filters: {
                        max_file_size: "10mb",
                        mime_types: [{
                            title: "Image files",
                            extensions: "jpg,jpeg,gif,png,tif,bmp,heic,heif"
                          }]
                      },
                      init: {
                        PostInit: (function () {
                            Belt_Option.map(Caml_option.nullable_to_opt(filelistEl.current), (function (__x) {
                                    __x.innerHTML = "";
                                  }));
                          }),
                        FilesAdded: (function (up, files) {
                            Belt_Array.map(files, (function (file) {
                                    Belt_Option.map(Caml_option.nullable_to_opt(filelistEl.current), (function (__x) {
                                            __x.innerHTML = "<div id=\"" + file.id + "\">" + file.name + " () <b></b></div>";
                                          }));
                                    up.start();
                                  }));
                          }),
                        UploadProgress: (function (up, file) {
                            Belt_Option.map(document.getElementById(file.id), (function (el) {
                                    return Belt_Option.map(Belt_Array.get(el.getElementsByTagName("b"), 0), (function (b) {
                                                  b.innerHTML = "<span>" + String(file.percent) + "%</span>";
                                                }));
                                  }));
                          }),
                        FileUploaded: (function (up, file, result) {
                            var response = (JSON.parse(result.response));
                            document.location.href = "/assets/" + response.result.id;
                          }),
                        Error: (function (up, err) {
                            Belt_Option.map(document.getElementById("console"), (function ($$console) {
                                    $$console.innerHTML = "\nError #" + String(err.code) + ": " + err.message;
                                  }));
                          })
                      }
                    })));
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("a", {
                      children: "Upload Photo",
                      ref: Caml_option.some(buttonEl),
                      className: Core.cx("w-full px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 shadow-sm hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto"),
                      href: "#"
                    }),
                JsxRuntime.jsx("div", {
                      ref: Caml_option.some(filelistEl)
                    })
              ],
              ref: Caml_option.some(containerEl)
            });
}

var UploadButton = {
  make: InstantPreviewPage$UploadButton
};

var aipainter_before = Aipainter_beforeJpg;

var aipainter_after = Aipainter_afterJpg;

function InstantPreviewPage(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
                      children: [
                        JsxRuntime.jsx("title", {
                              children: "Instant Photo to Painting Converter Online"
                            }),
                        JsxRuntime.jsx("meta", {
                              content: "Convert your favorite photo into a painting online for free! 100% hand-painted by master artists on canvas starting at $89 and painted in 1 week. Money back quality guarantee.",
                              name: "description"
                            })
                      ]
                    }),
                JsxRuntime.jsx(Ui.HeroSlider.make, {
                      title: "Convert Your Photo to Painting Instantly",
                      subtitle: "Preview with AI and get it hand made by a real artist",
                      title2: "",
                      description: "Use our photo to painting converter to preview your photo in a popular style of artwork. Get a professional artist to turn the picture into a painting, physically hand-painted on canvas and shipped to your door for as little as $89!",
                      action1: JsxRuntime.jsx(InstantPreviewPage$UploadButton, {}),
                      image1: Ui.$$Image.make(undefined, (
                            process.env.NODE_ENV === "development" ? "" : "https:"
                          ) + aipainter_before, "Woman in a robe", undefined),
                      image2: Ui.$$Image.make(undefined, (
                            process.env.NODE_ENV === "development" ? "" : "https:"
                          ) + aipainter_after, "Woman in a robe painted in watercolor in the style of Flower Market", undefined)
                    }),
                JsxRuntime.jsx(Layout.Container.make, {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h2", {
                                    children: "Picture to Painting by a Real Artist",
                                    className: Core.cx("text-base font-semibold uppercase tracking-wider text-indigo-600")
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "From Photo to Art to Canvas",
                                    className: Core.cx("mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl")
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Our image to painting converter can turn any photo into art for free. If you like what you see we can match you with a real artist who will actually paint it on canvas and ship it to your doorstep for as little as $89 and in as little as 2 weeks.",
                                    className: Core.cx("mx-auto mt-5 max-w-prose text-xl text-gray-500")
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Surprise someone with the gift of a real, textured, physical work of art. Preview for free instantly (just upload a photo).",
                                    className: Core.cx("mx-auto mt-5 max-w-prose text-xl text-gray-500")
                                  })
                            ],
                            className: Core.cx("mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8")
                          }),
                      className: Core.cx("my-16")
                    }),
                JsxRuntime.jsx(Layout.Container.make, {
                      children: JsxRuntime.jsx(GalleryList.make, {
                            items: items
                          }),
                      className: Core.cx("mb-16")
                    }),
                JsxRuntime.jsx(Layout.Container.make, {
                      children: JsxRuntime.jsx(Ideas.make, {
                            items: ideas
                          }),
                      className: Core.cx("mb-16 mx-auto")
                    }),
                JsxRuntime.jsxs(Layout.Container.make, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            className: Core.cx("w-full border-t border-gray-300")
                                          }),
                                      "aria-hidden": true,
                                      className: Core.cx("absolute inset-0 flex items-center")
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("span", {
                                            children: "Learn More About Instapainting",
                                            className: Core.cx("px-3 bg-white text-lg font-medium text-gray-900")
                                          }),
                                      className: Core.cx("relative flex justify-center")
                                    })
                              ],
                              className: Core.cx("relative")
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "",
                                      title2: "How It Works",
                                      children: "Our process is simple yet transformative. You provide a photo; our talented artists use it as a blueprint to create a hand-painted masterpiece. Whether it’s a portrait, a landscape, or a candid moment, we turn your photo into a painting that captures the essence of the original image in a new, artistic form."
                                    }),
                                JsxRuntime.jsxs(Landing.Content.make, {
                                      title1: "",
                                      title2: "Types of Paintings",
                                      children: [
                                        "Explore the wide range of artistic options we provide at Instapainting.  Our selection includes:",
                                        JsxRuntime.jsxs("ol", {
                                              children: [
                                                JsxRuntime.jsx("li", {
                                                      children: "Oil Paintings"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: "Watercolor Paintings"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: "Mixed Media Paintings"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: "Charcoal Drawings"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: "Digital Paintings"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: "Colored Pencil Drawings and more!"
                                                    })
                                              ],
                                              className: Core.cx("list-inside list-disc")
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "",
                                      title2: "Artistic Styles",
                                      children: "Match the artistic style of your favorite artist to suit your taste. From classic realism to impressionistic, modern to abstract, our artists can adapt to the style that best reflects your aesthetic. This flexibility allows each picture to painting conversion to be unique, providing a truly bespoke piece of art. Use our AI preview tool to see the result in select styles or just upload an example of the style with your order for the artist match it."
                                    }),
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "",
                                      title2: "Perfect for Any Occasion",
                                      children: "Whether it's a wedding photo, a family portrait, or a snapshot of a beloved pet, turning your photo into a custom canvas painting is an excellent way to commemorate special occasions or to give a memorable, unique, gift."
                                    })
                              ],
                              className: Core.cx("lg:grid lg:grid-cols-2 lg:gap-6")
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h4", {
                                      children: "Q: How long does turning my photo into a painting take?",
                                      className: Core.cx("font-bold")
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "A: The time varies depending on the complexity and style of the painting. Generally, it takes a few weeks to ensure the highest quality."
                                    }),
                                JsxRuntime.jsx("h4", {
                                      children: "Q: Can I request specific artistic styles?",
                                      className: Core.cx("font-bold")
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "A: Absolutely! Just upload an example of the style and let us know what about it you want incorporated into your painting; our artists will tailor the painting to your liking. You can also use our AI preview tool to see your painting in select artistic styles."
                                    }),
                                JsxRuntime.jsx("h4", {
                                      children: "Q: What if I have special requests for my painting?",
                                      className: Core.cx("font-bold")
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "A: We welcome special requests! Whether it’s a particular color scheme or adding details, our artists are adept at incorporating your needs into the final piece."
                                    })
                              ],
                              className: Core.cx("lg:grid")
                            })
                      ],
                      className: Core.cx("mb-16")
                    }),
                JsxRuntime.jsx(Layout.Container.make, {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("p", {
                                  children: "Instapainting is more than just a service; it's a gateway to preserving your most precious memories in an artistic and timeless form. With our skilled artists and a commitment to quality, your photos are not just converted into paintings; they are transformed into works of art that will be cherished for generations.",
                                  className: Core.cx("mt-8 text-xl text-gray-500 leading-8 text-center")
                                }),
                            className: Core.cx("text-lg max-w-prose mx-auto")
                          }),
                      className: Core.cx("mb-16")
                    }),
                JsxRuntime.jsxs(Layout.Container.make, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            className: Core.cx("w-full border-t border-gray-300")
                                          }),
                                      "aria-hidden": true,
                                      className: Core.cx("absolute inset-0 flex items-center")
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("span", {
                                            children: "Photo to Painting Techniques Compared",
                                            className: Core.cx("px-3 bg-white text-lg font-medium text-gray-900")
                                          }),
                                      className: Core.cx("relative flex justify-center")
                                    })
                              ],
                              className: Core.cx("relative")
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "Method 1",
                                      title2: "Image Convolutions",
                                      children: "This is the most basic technique and building block for all other techniques for turning a photo into a painting style. The technology usually applies a basic computational convolutional effect, where a small grid of pixels, called a kernel, modifies the underlying pixel values in a static way that is defined by the programmer. A common convolution is the gaussian blur, which applies a blur effect. A small grid of pixels modifies the RGB pixel values to achieve a blur, and this is applied across the whole image."
                                    }),
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "Method 2",
                                      title2: "Adobe Photoshop Filters",
                                      children: "Most image filters apply a series of image convolution algorithms with manually hand-tuned parameters. Because they are hand-tuned, they result in the basic and fixed effect on most images."
                                    }),
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "Method 3",
                                      title2: "Convolutional Neural Networks",
                                      children: "This is a much newer technique that is data driven. A neural network model is trained on images in general so that features can be extracted from the underlying image. Features are encoded grouping of pixels that match an abstract concept of some object that has been learned from the statistical model. For example, with enough training data, a model of images could identify the concept of a person, hand, or stop sign, from pixel values in an image because it can learn the invariant characteristics of those objects (the \"big picture\" so to speak). Features are extracted from the photo you upload as well as the style image that is being targeted. The convolutional network essentially applies a series of image convolution filters, much like Photoshop filters, and tunes the parameters of each filter automatically to automatically try to match the features extracted from the style image."
                                    }),
                                JsxRuntime.jsx(Landing.Content.make, {
                                      title1: "Method 4",
                                      title2: "Human Artists",
                                      children: "This is arguably the most advanced and flexible technique. A master artist can interpret what makes up a certain style used in a painting style and apply the same style to another photo reference. The downsides is that it does cost some money to do and they are a bit slower."
                                    })
                              ],
                              className: Core.cx("lg:grid lg:grid-cols-2 lg:gap-6")
                            }),
                        JsxRuntime.jsx(Landing.Content.make, {
                              title1: "",
                              title2: "The Instapainting Method",
                              children: "At Instapainting, we combine Convolutional Neural Networks and human artists to give the best experience. You can preview your artwork in select styles instantly using our AI Painter, and then get a master human artist to interpret and make it real and physical, and clean up the shortcomings of the AI Painter."
                            })
                      ],
                      className: Core.cx("mb-16")
                    })
              ]
            });
}

var make = InstantPreviewPage;

var $$default = InstantPreviewPage;

export {
  items ,
  ideas ,
  Plupload ,
  UploadButton ,
  aipainter_before ,
  aipainter_after ,
  make ,
  $$default as default,
}
/*  Not a pure module */
